/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, getter-return, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import {
  byKeys,
  filterBy,
} from '@linc-technologies/linced-common/utils/arrays';

export default class PendingNotifications extends Component {
  // Services
  @service
  store;

  @tracked
  rollReturns;

  // pendingApproval returns the most recently created roll return which is currently pending approval.
  @computed('rollReturns.@each.{status,createTime}')
  get pendingApproval() {
    if (isEmpty(this.rollReturns)) {
      return;
    }
    let pending = filterBy(this.rollReturns, 'status', 'Pending approval');
    return pending.sort(byKeys('createTime'))[0];
  }

  // pendingUpload returns the most recently created roll return which is currently pending upload.
  @computed('rollReturns.@each.{status,createTime}')
  get pendingUpload() {
    if (isEmpty(this.rollReturns)) {
      return;
    }
    let pending = filterBy(
      this.rollReturns,
      'status',
      'Approved (pending upload)',
    );
    return pending.sort(byKeys('createTime'))[0];
  }

  init() {
    super.init(...arguments);

    this.store
      .query('nz-roll-returns/roll-return', { validateOnly: false })
      .then((rollReturns) => {
        this.rollReturns = rollReturns;
      });
  }
}
